import { UNIT_SYSTEMS, type UnitSystem } from './unitSystems';

export interface UnitFormatter {
  system: UnitSystem;
  heightSymbol: string;
  distanceSymbol: string;
  speedSymbol: string;
  /** Metres → rounded number in the height unit, locale formatted (no symbol). */
  heightValue: (m: number) => string;
  /** Metres → "1,234 ft". */
  height: (m: number) => string;
  /** Metres → "1.2 km". */
  distance: (m: number, digits?: number) => string;
  /** Square metres → "3.4 km²". */
  area: (m2: number) => string;
  /** m/s → rounded number in the speed unit (no symbol). */
  speedValue: (ms: number) => number;
  /** m/s → "12 km/h". */
  speed: (ms: number) => string;
  /** °C → "54 °F". */
  temperature: (c: number) => string;
  /** Millimetres → "0.12 in". */
  precip: (mm: number) => string;
}

export function createUnitFormatter(system: UnitSystem): UnitFormatter {
  const { height: h, distance: d, speed: s, precip: p, temperature: temp } = UNIT_SYSTEMS[system];
  const heightValue = (m: number) => Math.round(m / h.metres).toLocaleString();
  const speedValue = (ms: number) => Math.round(ms / s.metres);
  return {
    system,
    heightSymbol: h.symbol,
    distanceSymbol: d.symbol,
    speedSymbol: s.symbol,
    heightValue,
    height: (m) => `${heightValue(m)} ${h.symbol}`,
    distance: (m, digits = 1) => `${(m / d.metres).toFixed(digits)} ${d.symbol}`,
    area: (m2) => `${(m2 / d.metres ** 2).toFixed(1)} ${d.symbol}²`,
    speedValue,
    speed: (ms) => `${speedValue(ms)} ${s.symbol}`,
    temperature: (c) => `${Math.round(temp.fromCelsius(c))} ${temp.symbol}`,
    precip: (mm) => `${(mm / p.metres).toFixed(system === 'metric' ? 1 : 2)} ${p.symbol}`,
  };
}
